import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { CanDeactivateService } from '../../common/common.service';

import { AdminTableEditorComponent } from './table-editor.component';

export const TableEditorRoutes: Routes = [
    {
        path: 'table-editor',
        component: AdminTableEditorComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateService],
    },
];
